import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import styles from './_singleElement.css'

const propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  primaryColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  type: PropTypes.oneOf(['spin', 'comet', 'pulse']),
  className: PropTypes.string,
}

const defaultProps = {
  backgroundColor: 'transparent',
  type: 'spin',
  height: 24,
  width: 24,
}

export function Loader (props) {
  const {
    type,
    backgroundColor,
    height,
    width,
    className,
    ...rest
  } = props

  const classname = classnames(styles.container, styles[type], className)
  const _containerStyles = { width, height, backgroundColor: backgroundColor }
  const isPulse = type === 'pulse'

  return (
    <span style={!isPulse ? _containerStyles : null} className={classname} {...rest} />
  )
}

Loader.propTypes = propTypes
Loader.defaultProps = defaultProps

export default Loader
